import { combineReducers } from 'redux-immutable'
import headerReducer from './header-reducer'

export default combineReducers({
  header: headerReducer,
})



// WEBPACK FOOTER //
// ./src/reducers/header/index.js